import React from 'react';
import { Card, CardContent } from './ui/card';
import { Wind, Droplets, Eye, Thermometer } from 'lucide-react';

const WeatherContext = ({ weatherData }) => {
  if (!weatherData) return null;

  const conditions = [
    {
      icon: Thermometer,
      label: 'Temperature',
      value: `${Math.round(weatherData.temperature?.display || 0)}°C`,
      subtitle: `Feels like ${Math.round(weatherData.temperature?.apparent || 0)}°C`
    },
    {
      icon: Wind,
      label: 'Wind',
      value: `${Math.round(weatherData.conditions?.windSpeed || 0)} km/h`,
      subtitle: weatherData.conditions?.windSpeed > 15 ? 'Breezy' : 'Light'
    },
    {
      icon: Droplets,
      label: 'Humidity',
      value: `${Math.round(weatherData.conditions?.relativeHumidity || 50)}%`,
      subtitle: weatherData.conditions?.relativeHumidity > 70 ? 'Humid' : 'Comfortable'
    },
    {
      icon: Eye,
      label: 'Precipitation',
      value: weatherData.conditions?.precipitation > 0 ? 'Expected' : 'None',
      subtitle: weatherData.conditions?.precipitation > 0 ? 'Bring protection' : 'Clear conditions'
    }
  ];

  return (
    <Card className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-sm border-white/20">
      <CardContent className="p-4">
        <h3 className="text-sm font-medium text-muted-foreground mb-3">Current Conditions</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {conditions.map((condition, index) => (
            <div key={index} className="text-center">
              <condition.icon className="h-5 w-5 mx-auto mb-2 text-primary" />
              <div className="text-sm font-medium text-gray-800 dark:text-gray-200">
                {condition.value}
              </div>
              <div className="text-xs text-muted-foreground">
                {condition.subtitle}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default WeatherContext;